export const UPDATE_FORM_ID = 'updateStationForm';
export const CREATE_FORM_ID = 'createStationForm';
export const UPDATE_BEWERTUNG_FORM_ID = 'updateBewertungForm';
export const CREATE_BEWERTUNG_FORM_ID = 'createBewertungForm';
export const ROTATIONSPLAN_STORAGE_KEY = 'rotationsplan-storage';
